import { Product, Variant } from "../../types/types";

export function isInStock(product: Product): boolean {
  const variants: Variant[] = product.variants;
  return variants?.some(
    (variant) => variant?.availability?.unavailableReason !== "outOfStock",
  );
}
